<div class="row">
    <div class="pt-3 top_grid_agg">
        <div class="col-12">
            <div class="col-12 pl-2">
                <h6>Manual Search Criteria - Actual Orders (OWK)</h6>
                <!-- <p class="content-Heading">Select Route, Timezone</p> -->
            </div>
            <div class="content px-2 d-flex flex-wrap align-items-center" style="gap: 10px;">

                <mat-form-field class="col-auto" style="flex: 1;">
                    <mat-label>Route</mat-label>
                    <input matInput placeholder="Route (ABC/ABCD)" (blur)='validateInput()' [required]="true"
                        [(ngModel)]="route" maxlength="5">
                    <mat-hint class="mat-error" *ngIf="enableError">{{routeErrorMsg}}</mat-hint>
                </mat-form-field>

                <mat-form-field class="col-auto" style="flex: 1;">
                    <mat-label>Route Date</mat-label>
                    <input matInput (dateChange)="OnDateChange($event.value,'routeDt')"
                        [matDatepicker]="routeDateId" [(ngModel)]="routeDate">
                    <mat-datepicker-toggle matIconSuffix [for]="routeDateId"></mat-datepicker-toggle>
                    <mat-datepicker #routeDateId></mat-datepicker>
                    <mat-hint class="mat-error" *ngIf="enableError">{{dateErrorMsg}}</mat-hint>
                </mat-form-field>

                <mat-form-field class="col-auto" style="flex: 1;">
                    <mat-label>Dispatch Date</mat-label>
                    <input matInput (dateChange)="OnDateChange($event.value,'dispatch')"
                        [matDatepicker]="dispatchDateId" [(ngModel)]="dispatchDate">
                    <mat-datepicker-toggle matIconSuffix [for]="dispatchDateId"></mat-datepicker-toggle>
                    <mat-datepicker #dispatchDateId></mat-datepicker>
                    <mat-hint class="mat-error" *ngIf="enableError">{{dateErrorMsg}}</mat-hint>
                </mat-form-field>

                <mat-form-field class="col-auto" style="flex: 1;">
                    <mat-label>Pick Up Date</mat-label>
                    <input matInput (dateChange)="OnDateChange($event.value,'pickup')" [matDatepicker]="pickDateId"
                        [(ngModel)]="pickDate">
                    <mat-datepicker-toggle matIconSuffix [for]="pickDateId"></mat-datepicker-toggle>
                    <mat-datepicker #pickDateId></mat-datepicker>
                    <mat-hint class="mat-error" *ngIf="enableError">{{dateErrorMsg}}</mat-hint>
                </mat-form-field>

                <mat-form-field class="col-auto" style="flex: 1;">
                    <mat-label>Unload Date</mat-label>
                    <input matInput (dateChange)="OnDateChange($event.value,'unloadDt')" [matDatepicker]="unloadDateId"
                        [(ngModel)]="unloadDate">
                    <mat-datepicker-toggle matIconSuffix [for]="unloadDateId"></mat-datepicker-toggle>
                    <mat-datepicker #unloadDateId></mat-datepicker>
                    <mat-hint class="mat-error" *ngIf="enableError">{{dateErrorMsg}}</mat-hint>
                </mat-form-field>

                <mat-form-field class="col-auto" style="flex: 1;">
                    <mat-label>Time Zone</mat-label>
                    <mat-select (blur)='validateTimeZone()' [required]="true" [(ngModel)]="timeZoneChoosen">
                        <mat-option value='EST'>EST</mat-option>
                        <mat-option value='CST'>CST</mat-option>
                        <mat-option value='MST'>MST</mat-option>
                        <mat-option value='PST'>PST</mat-option>
                    </mat-select>
                    <mat-hint class="mat-error" *ngIf="enableError">{{timeZoneErrorMsg}}</mat-hint>
                </mat-form-field>

                <mat-form-field class="col-auto" style="flex: 1;">
                    <mat-label>PDF</mat-label>
                    <mat-select (blur)='validatePdfChoosen()' [required]="true" [(ngModel)]="pdfTypeChoosen">
                        <mat-option value='O'>Oldest</mat-option>
                        <mat-option value='L'>Latest</mat-option>
                    </mat-select>
                    <mat-hint class="mat-error" *ngIf="enableError">{{pdfErrorMsg}}</mat-hint>
                </mat-form-field>

                <mat-form-field class="col-auto" style="flex: 1;">
                    <mat-label>Truck Type</mat-label>
                    <mat-select [(value)]="truckTypeChoosen" [(ngModel)]="truckTypeChoosen">
                        <mat-option *ngFor="let truck of truckTypes" [value]="truck">
                            {{truck.trailerType}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

            </div>

            <div class="col-11 text-end" >
                <button class="submit-btn" mat-raised-button (click)="search()">
                    SEARCH
                </button>
            </div>


            <div class="grid-agg" *ngIf="enableGrid">
                <ag-grid-angular #agGrid [ngStyle]="{'height': dynamicHeight + 'px', 'width':'100%' }" id="myGrid"
                    class="ag-theme-balham" [pagination]="setPagination" [columnDefs]="columnDefs" [rowData]="rowData"
                    [icons]="icons" [defaultColDef]="defaultColDef" [suppressCellFocus]="true"
                    [paginationPageSize]="paginationPageSize" (gridReady)="onGridReady($event)" [theme]="'legacy'"
                    (window:resize)="sizeToFit()" [context]="context" [enableCellTextSelection]="true"
                    [ensureDomOrder]="true" [rowHeight]="40"[suppressDragLeaveHidesColumns]="true" >
                </ag-grid-angular>

                <div class="row col-12" style="bottom: 24px;position: relative !important;">
                    <div class="w-25 col-4">
                        <div>
                            <label class="page-drpdwn-label">Records / Page: </label>&nbsp;
                            <select class="page-drpdwn" (change)="onPageSizeChanged($event)">
                                <option value="5">5</option>
                                <option value="10" selected>10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                            </select>
                        </div>
                    </div>

                    <div style="display: flex;" class="pagination_text col-4 offset-1">
                        <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToFirstPage()"
                            [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                            first_page</mat-icon>

                        <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToPreviousPage()"
                            [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                            keyboard_arrow_left</mat-icon>

                        <p class="total_row_text">Total Row {{rowCount}}</p>

                        <mat-icon style="cursor: pointer; margin-top: -4px;"
                            [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
                            (click)="goToNexpage()">keyboard_arrow_right
                        </mat-icon>

                        <mat-icon style="cursor: pointer; margin-top: -4px;"
                            [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
                            (click)="goToLastPage()">last_page
                        </mat-icon>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>